"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportBlockType = exports.ReportType = exports.ReportStatus = void 0;
var ReportStatus;
(function (ReportStatus) {
    ReportStatus["PUBLISHED"] = "PUBLISHED";
    ReportStatus["PRE_RELEASE"] = "PRE_RELEASE";
    ReportStatus["ARCHIVED"] = "ARCHIVED";
})(ReportStatus = exports.ReportStatus || (exports.ReportStatus = {}));
var ReportType;
(function (ReportType) {
    ReportType["FREE"] = "FREE";
    ReportType["PREMIUM"] = "PREMIUM";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
var ReportBlockType;
(function (ReportBlockType) {
    ReportBlockType["CHART"] = "CHART";
    ReportBlockType["DOCUMENT"] = "DOCUMENT";
    ReportBlockType["TEXT"] = "TEXT";
})(ReportBlockType = exports.ReportBlockType || (exports.ReportBlockType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwb3J0LmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcmVwb3J0cy9yZXBvcnQuZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFFSCxJQUFZLFlBSVg7QUFKRCxXQUFZLFlBQVk7SUFDdEIsdUNBQXVCLENBQUE7SUFDdkIsMkNBQTJCLENBQUE7SUFDM0IscUNBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUpXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBSXZCO0FBRUQsSUFBWSxVQUdYO0FBSEQsV0FBWSxVQUFVO0lBQ3BCLDJCQUFhLENBQUE7SUFDYixpQ0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSFcsVUFBVSxHQUFWLGtCQUFVLEtBQVYsa0JBQVUsUUFHckI7QUFFRCxJQUFZLGVBSVg7QUFKRCxXQUFZLGVBQWU7SUFDekIsa0NBQWUsQ0FBQTtJQUNmLHdDQUFxQixDQUFBO0lBQ3JCLGdDQUFhLENBQUE7QUFDZixDQUFDLEVBSlcsZUFBZSxHQUFmLHVCQUFlLEtBQWYsdUJBQWUsUUFJMUIifQ==